import { useTranslation } from 'react-i18next';

import type { IProspectContact } from '../../../interfaces/prospects';
import { TRANSLATIONS_GLOBAL } from '../../../translations/commons';
import { TRANSLATIONS_PROSPECTS } from '../../../translations/prospects';
import { EMPTY_FIELD } from '../../../utils/prospects/prospects';
import PanelRow from '../PanelRow/PanelRow';

interface IContactDetailsProps {
  contact: IProspectContact;
  showTitle?: boolean;
  requiredTitle?: boolean;
}

const ContactDetails = ({ contact, showTitle = false, requiredTitle = false }: IContactDetailsProps) => {
  const { t } = useTranslation();

  const rows = [
    { label: t(TRANSLATIONS_GLOBAL.name), value: contact.name || EMPTY_FIELD },
    ...(showTitle || requiredTitle
      ? [{ label: t(TRANSLATIONS_PROSPECTS.profile.fields.title), value: contact.title || EMPTY_FIELD }]
      : []),
    { label: t(TRANSLATIONS_GLOBAL.email), value: contact.email || EMPTY_FIELD },
    { label: t(TRANSLATIONS_GLOBAL.phone), value: contact.phone || EMPTY_FIELD }
  ];

  return (
    <>
      {rows.map(({ label, value }) => (
        <PanelRow key={label} label={label} value={value} empty={value === EMPTY_FIELD} />
      ))}
    </>
  );
};

export default ContactDetails;
